import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-counter-bid-disclosure',
  templateUrl: './counter-bid-disclosure.component.html',
  styleUrls: ['./counter-bid-disclosure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CounterBidDisclosureComponent {}
